<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="invokeMethod($event)" :add-list="addList" perm="companies.update"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetCustomer(true)"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="customer != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip right v-if="hasPerm('companies.update')">
                                        <template slot="activator">
                                            <v-btn
                                                style="max-width: 120px; text-transform: none"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="customer.status_class"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="customer.status">{{
                                                    status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"
                                                }}</v-icon>
                                                <span class="white--text">{{
                                                    status_loader ? $t("lang.loading") : customer.status == "1" ? $t("lang.active") : $t("lang.disabled")
                                                }}</span>
                                            </v-btn>
                                        </template>
                                        {{ customer.status == "0" ? $t("lang.click_to_activate") : $t("lang.click_to_deactivate") }}
                                    </bc-tooltip>
                                    <v-chip v-else disabled round text-color="white" class="chip-padding-left-4 mr-auto fs-14" :color="customer.status_class">
                                        <span><v-icon v-model="customer.status" class="mr-2">check_circle</v-icon></span>
                                        <span class="white--text">{{ customer.status == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                    </v-chip>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <div class="ml-auto">
                                        <bc-tooltip perm="companies.update">
                                            <template slot="activator">
                                                <v-btn @mouseup.left="openCompanyModal()" icon>
                                                    <v-icon color="indigo">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.modifyCompany") }}
                                        </bc-tooltip>
                                    </div>
                                </v-flex>
                                <v-flex xs12 py-0>
                                    <bc-tooltip top :disabled="!hasPerm('companies.update')">
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg ? errorImg : customer.logo"
                                                height="150px"
                                                width="150px"
                                                :class="{ clickable: hasPerm('companies.update') }"
                                                class="rounded-circle mx-auto"
                                                @mouseup.left="hasPerm('companies.update') ? $refs.croppa.chooseFile() : ''"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t("lang.uploadImage") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex py-1>
                                    <p class="display-1 mb-0 text-xs-center">{{ customer.company }}</p>
                                    <a class="display-0 mb-0 text-xs-center" :href="'http://' + customer.website" target="_blank">{{ customer.website }}</a>
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="entity_phones" class="my-0"></v-divider>
                            <bc-list
                                v-if="customer.entity_phones"
                                :items="customer.entity_phones"
                                prepend-icon="phone"
                                perm="companies.update"
                                @invoke-method="showPhone($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.phone_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="customer.entity_addresses" class="my-0"></v-divider>
                            <bc-list
                                v-if="customer.entity_addresses"
                                :items="customer.entity_addresses"
                                prepend-icon="location_on"
                                perm="companies.update"
                                @invoke-method="showAddress($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ $t(`lang.${data.item.address_type}`) }}</v-flex>
                                    <v-flex list-sub>{{ data.item.address1 }}</v-flex>
                                    <v-flex list-sub>{{ `${data.item.city}, ${data.item.state} ${data.item.zip_code}` }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" prepend-position="top" perm="companies.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.shipping_number")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ customer.shipping_number || "---" }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.billing_method")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{
                                                customer.correspondence_method ? $t(`lang.${customer.correspondence_method}`) : "---"
                                            }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.currency_code")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ customer.currency_code || "---" }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.payment_terms")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ customer.payment_terms_description || "---" }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.has_nda")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ customer.has_nda == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.has_contract")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ customer.has_contract == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <!-- <bc-list prepend-icon="description" perm="companies.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-flex title>{{ $t("lang.notes") }}</v-flex>
                                    <v-flex style="white-space: pre-line">{{ customer.notes ? customer.notes : $t("lang.none") }}</v-flex>
                                </template>
                            </bc-list> -->
                            <bc-notes-list
                                :items="customer.notes || []"
                                perm="companies.update"
                                entity-object="customers"
                                :api-url="`customers/${this.$route.params.id}`"
                                :scope="customer.scope"
                                state-property="notes"
                                state-mutate="mutateCustomer"
                                :id="this.$route.params.id"
                                sendObject="saveCustomer"
                            ></bc-notes-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <bc-tabs
                                    :tabs="subComponents"
                                    :selectedComponent="selectComponent(selectedComponent)"
                                    @button="$nextTick(() => (selectedComponent = $event))"
                                    :update-params="true"
                                >
                                </bc-tabs>
                                <v-card elevation="0" :key="refresh">
                                    <keep-alive>
                                        <component v-if="subComponentsMap[selectedComponent]" :is="component" class="tab"></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>

        <bc-dialog :value="customer_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.modifyCompany") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="customer_dialog"
                        :dialog-status="customer_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formCustomer">
                        <v-container pa-0 grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 column>
                                    <v-text-field
                                        v-model="customer.company"
                                        :label="$t('lang.company')"
                                        :counter="showCounter(customer.company, 'customer.company')"
                                        :rules="ifValid('customers.company')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="customer.shipping_number"
                                        :label="$t('lang.shipping_number')"
                                        :counter="showCounter(customer.shipping_number, 'customer.shipping_number')"
                                        :rules="ifValid('customers.shipping_number')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="customer.website"
                                        :label="$t('lang.website')"
                                        :counter="showCounter(customer.website, 'customer.website')"
                                        :rules="ifValid('customers.website')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="customer.turn_around_days"
                                        :label="$t('lang.turn_around_days')"
                                        :counter="showCounter(customer.turn_around_days, 'customer.turn_around_days')"
                                        :rules="ifValid('customers.turn_around_days')"
                                        type="number"
                                    ></v-text-field>
                                    <bc-autocomplete
                                        v-model="customer.payment_term_id"
                                        :label="$t('lang.payment_terms')"
                                        :items="payment_terms"
                                        item-value="payment_term_id"
                                        item-text="description"
                                        :rules="ifValid('customers.payment_term_id')"
                                    ></bc-autocomplete>
                                    <bc-autocomplete
                                        v-model="customer.currency_id"
                                        :label="$t('lang.currency_id')"
                                        :items="currencies"
                                        item-value="currency_id"
                                        item-text="name"
                                        :rules="ifValid('customers.currency_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 column align-self-start>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_nda") }}</span>
                                    <v-switch
                                        v-model="customer.has_nda"
                                        :label="customer.has_nda == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_contract") }}</span>
                                    <v-switch
                                        v-model="customer.has_contract"
                                        :label="customer.has_contract == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.correspondence_method") }}</span>
                                    <v-switch
                                        v-model="customer.correspondence_method"
                                        :label="customer.correspondence_method == 'electronic' ? $t('lang.electronic') : $t('lang.mail')"
                                        true-value="electronic"
                                        false-value="mail"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="customer_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="saveCustomers()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        <bc-phone-dialog
            ref="phoneDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="customer.entity_phones || []"
            :scope="customer.scope"
            @eventname="updatePhones"
        ></bc-phone-dialog>
        <bc-address-dialog
            ref="addressDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="customer.entity_addresses || []"
            :scope="customer.scope"
            @eventname="updateAddresses"
        ></bc-address-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

import { customersProfileComponents } from "Modules/companies/customers/components/profile.data.js";
import { relativeTimeThreshold } from "moment";

export default {
    data() {
        return {
            expandedIndexes: [],
            subComponentsMap: {},
            subComponents: customersProfileComponents,
            selectedComponent: "users",
            component: null,
            tabs: [
                { title: "people", name: "users" },
                { title: "parts", name: "parts", perms: ["parts.read"] },
                { title: "settings", name: "settings", perms: ["packing_lists.read"] },
            ],
            validPhone: false,
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetCustomer: _.debounce(this.getCustomer, 1500, { maxWait: 1500, leading: true, trailing: false }),
            addList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", icon: "phone" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", icon: "location_on" },
            ],
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", perms: ["companies.update"] },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", perms: ["companies.update"] },
                { title: this.$t("lang.refresh"), action: "dbGetCustomer" },
            ],
            customer_dialog: false,
            formData: {},
            customer: {},
            ship_label_types: [
                { name: "normal", display: "Normal" },
                { name: "adi", display: "ADI" },
                { name: "magna", display: "Magna" },
            ],
            status_loader: false,
            file: "",
            newFile: {
                logo_file: "",
            },
            growText: 0,
            updatePhoto: 0,
            refresh: 0,
            errorImg: AppConfig.defaultProfileLogo,
            showErrorImg: false,
            ship_label_type_display: "",
        };
    },
    computed: {
        ...mapState({
            rules_customers: (state) => state.customers.rules_customers,
            customers: (state) => state.customers.customers,
            entity_addresses: (state) => state.customers.entity_addresses,
            entity_phones: (state) => state.customers.entity_phones,
            packing_list_fields_options: (state) => state.customers.packing_list_fields_options,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            options: (state) => state.options.options,
            selectedCustomer: (state) => state.customers.selectedCustomer,
        }),
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        store
            .dispatch("fetchCustomer", {
                id: id,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.customer) {
                    next((vm) => {
                        vm.customer = vm.assignObj2(data.customer, vm.rules_customers);
                        vm.selectedComponent = to.params.tab && vm.tabs.map((t) => t.name).indexOf(to.params.tab) >= 0 ? to.params.tab : vm.tabs[0].name;
                        // vm.ship_label_type_display = vm.ship_label_types.find((t) => t.name == vm.customer.ship_label_type).display;
                        vm.customer_dialog = false;
                        vm.toggleModalLoader(false);
                        vm.validationOff();
                        vm.finishLoader(false);
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        this.$store
            .dispatch("fetchCustomer", {
                id: id,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.customer) {
                    this.customer = this.assignObj2(data.customer, this.rules_customers);
                    this.selectedComponent = to.params.tab && this.tabs.map((t) => t.name).indexOf(to.params.tab) >= 0 ? to.params.tab : this.tabs[0].name;
                    this.ship_label_type_display = this.ship_label_types.find((t) => t.name == this.customer.ship_label_type).display;
                    this.customer_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(false);
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    created() {
        this.registerComponents();
    },
    watch: {
        selectedCustomer: {
            handler: function () {
                this.customer = { ...this.selectedCustomer };
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions(["fetchCustomer", "saveCustomer", "deleteCustomer", "fetchCurrencies", "fetchPaymentTerms", "fetchOptions", "initializeMutate"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader", "mutateCustomer"]),
        callMethod(data) {
            console.log("callMethod");
            this.initializeMutate({ property: "notes", with: data });
        },
        registerComponents() {
            this.subComponents.forEach((cData) => {
                cData.import().then((component) => {
                    this.$set(this.subComponentsMap, cData.name, component.default);
                });
            });
        },
        selectComponent(componentName) {
            this.component = this.subComponentsMap[componentName];
        },
        getCustomer(pg_refresh = false) {
            this.startLoader();

            this.fetchCustomer({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.customer) {
                    this.customer = this.assignObj2(data.customer, this.rules_customers);
                    //this.ship_label_type_display = this.ship_label_types.find((t) => t.name == this.customer.ship_label_type).display;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                } else {
                    this.$router.push({ name: "customers" });
                }
            });
        },
        saveCustomers() {
            this.validationOn();

            this.$nextTick(() => {
                if (this.validateForm("formCustomer")) {
                    this.toggleModalLoader(true);
                    let body = this.prepForm(this.customer, this.rules_customers);

                    this.saveCustomer({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.customer) {
                            // this.customer = this.assignObj2(data.customer, this.rules_customers);
                            this.validationOff();
                            this.customer_dialog = false;
                        }
                        this.toggleModalLoader(false);
                    });
                }
            });
        },
        changeStatus() {
            this.status_loader = true;
            let status = this.customer.status == 1 ? 0 : 1;
            let body = { company_id: `${this.$route.params.id}`, status: status };

            this.saveCustomer({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.customer) {
                    this.customer = this.assignObj2(data.customer, this.rules_customers);
                    this.status_loader = false;
                    this.finishLoader();
                }
            });
        },
        handleFileUpload(file) {
            this.toggleModalLoader(true);

            let body = { company_id: `${this.$route.params.id}`, logo_file: file };

            this.saveCustomer({
                body: body,
            })
                .then((data) => {
                    if (typeof data != "undefined" && data.customer) {
                        this.customer = this.assignObj2(data.customer, this.rules_customers);
                        this.status_loader = false;
                        this.finishLoader();
                    }
                })
                .finally(() => {
                    this.toggleModalLoader(false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
        async openCompanyModal() {
            this.customer_dialog = true;
            this.growText++;

            if (this.payment_terms.length == 0) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.currencies.length == 0) await this.fetchCurrencies({ body: { options: 1 } });
        },
        updateAddresses(addresses) {
            this.customer.entity_addresses = addresses;
        },
        updatePhones(phones) {
            this.customer.entity_phones = phones;
        },
        showAddress(item) {
            if (item) this.$refs.addressDialog.showAddress(item);
        },
        showPhone(item) {
            if (item) this.$refs.phoneDialog.showPhone(item);
        },
    },
};
</script>
